var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 50,
    viewBox: "0 0 142 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.589 0H24.8459C11.1239 0 0 11.1239 0 24.8459V24.846C0 38.568 11.1239 49.6919 24.8459 49.6919H116.589C130.311 49.6919 141.435 38.568 141.435 24.8459C141.435 11.1239 130.311 0 116.589 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2284 13.2696C25.9609 13.559 25.8064 14.0013 25.8064 14.5801V35.1123C25.8064 35.6912 25.9609 36.1334 26.2376 36.4113L26.3091 36.4739L37.7656 24.9701V24.7131L26.2999 13.207L26.2284 13.2696Z",
    fill: "url(#paint0_linear_63_118)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5775 28.8155L37.7563 24.9786V24.7099L41.5775 20.873L41.6605 20.924L46.1804 23.5035C47.4741 24.2353 47.4741 25.444 46.1804 26.185L41.6605 28.7645L41.5775 28.8155Z",
    fill: "url(#paint1_linear_63_118)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6607 28.765L37.7565 24.8447L26.2285 36.4203C26.6505 36.8741 27.3585 36.925 28.1494 36.4828L41.6607 28.765Z",
    fill: "url(#paint2_linear_63_118)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6607 20.9242L28.1494 13.2179C27.3585 12.7641 26.6482 12.8266 26.2285 13.2805L37.7565 24.8444L41.6607 20.9242Z",
    fill: "url(#paint3_linear_63_118)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5776 28.6816L28.1585 36.3369C27.409 36.7699 26.7402 36.7398 26.309 36.3462L26.2375 36.4179L26.309 36.4805C26.7402 36.8718 27.409 36.9042 28.1585 36.4712L41.6698 28.765L41.5776 28.6816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1804 26.0511L41.5659 28.6816L41.6489 28.765L46.1688 26.1854C46.8168 25.8149 47.1351 25.3287 47.1351 24.8447C47.0959 25.2893 46.7661 25.7107 46.1804 26.0511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1494 13.3524L46.1805 23.6382C46.7662 23.9693 47.096 24.4023 47.1468 24.8446C47.1468 24.3606 46.8285 23.8743 46.1805 23.5039L28.1494 13.2181C26.8556 12.4748 25.8064 13.0954 25.8064 14.5797V14.714C25.8064 13.2273 26.8556 12.6184 28.1494 13.3524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6398 19.6547C82.8027 19.6547 82.0973 19.3606 81.5392 18.7817C80.9855 18.219 80.6769 17.4433 80.6903 16.6514C80.6903 15.8062 80.9763 15.0907 81.5392 14.5234C82.0946 13.9445 82.8005 13.6504 83.6376 13.6504C84.4656 13.6504 85.171 13.9445 85.7382 14.5234C86.3011 15.1092 86.5871 15.8247 86.5871 16.6514C86.578 17.4989 86.2919 18.2144 85.7382 18.7794C85.1828 19.3629 84.4769 19.6547 83.6398 19.6547ZM58.7323 19.6547C57.9134 19.6547 57.2032 19.3652 56.622 18.7933C56.0457 18.2237 55.7527 17.5035 55.7527 16.6537C55.7527 15.8039 56.0457 15.0837 56.622 14.5141C57.1919 13.9422 57.9021 13.6527 58.7323 13.6527C59.1382 13.6527 59.5323 13.7338 59.9108 13.8982C60.2817 14.058 60.5839 14.2756 60.8075 14.5419L60.8629 14.609L60.2382 15.225L60.1737 15.1486C59.8204 14.7272 59.3478 14.5211 58.7231 14.5211C58.1651 14.5211 57.6785 14.7202 57.2769 15.1138C56.8737 15.5098 56.6683 16.0285 56.6683 16.656C56.6683 17.2836 56.8737 17.8022 57.2769 18.1982C57.6785 18.5918 58.1651 18.791 58.7231 18.791C59.3177 18.791 59.8183 18.5918 60.2081 18.1982C60.4387 17.9666 60.5817 17.6424 60.6323 17.2326H58.6285V16.3666H61.4925L61.5043 16.4453C61.5247 16.5912 61.5457 16.7417 61.5457 16.8806C61.5457 17.6795 61.3059 18.3256 60.8306 18.8025C60.2909 19.3675 59.5855 19.6547 58.7323 19.6547ZM91.8495 19.5319H90.9661L88.2613 15.1856L88.2844 15.9683V19.5296H87.4011V13.7754H88.4086L88.4366 13.8194L90.9801 17.9133L90.957 17.133V13.7754H91.8495V19.5319ZM77.0032 19.5319H76.1086V14.6415H74.5565V13.7754H78.5527V14.6415H77.0005V19.5319H77.0032ZM73.8274 19.5319H72.9349V13.7754H73.8274V19.5319ZM68.8118 19.5319H67.9194V14.6415H66.3677V13.7754H70.364V14.6415H68.8118V19.5319ZM65.8027 19.5227H62.3806V13.7754H65.8027V14.6415H63.2753V16.2207H65.5559V17.0774H63.2753V18.6567H65.8027V19.5227ZM82.1941 18.1866C82.593 18.5872 83.0774 18.7887 83.6398 18.7887C84.2188 18.7887 84.6914 18.5918 85.086 18.1866C85.478 17.793 85.6763 17.2766 85.6763 16.6537C85.6763 16.0308 85.478 15.5121 85.0882 15.1208C84.6893 14.7202 84.2027 14.5187 83.6425 14.5187C83.0634 14.5187 82.5909 14.7156 82.1984 15.1208C81.8065 15.5144 81.6081 16.0308 81.6081 16.6537C81.6081 17.2766 81.8043 17.7953 82.1941 18.1866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8769 27.3069C73.2118 27.3069 71.8618 28.5754 71.8618 30.3251C71.8618 32.0589 73.2204 33.3433 74.8769 33.3433C76.5419 33.3433 77.8914 32.066 77.8914 30.3251C77.8914 28.5754 76.5419 27.3069 74.8769 27.3069ZM74.8769 32.1473C73.9656 32.1473 73.1817 31.3901 73.1817 30.318C73.1817 29.23 73.9677 28.4887 74.8769 28.4887C75.7876 28.4887 76.5715 29.23 76.5715 30.318C76.5737 31.3972 75.7876 32.1473 74.8769 32.1473ZM68.2995 27.3069C66.6344 27.3069 65.2849 28.5754 65.2849 30.3251C65.2849 32.0589 66.643 33.3433 68.2995 33.3433C69.9645 33.3433 71.314 32.066 71.314 30.3251C71.314 28.5754 69.9629 27.3069 68.2995 27.3069ZM68.2995 32.1473C67.3887 32.1473 66.6043 31.3901 66.6043 30.318C66.6043 29.23 67.3903 28.4887 68.2995 28.4887C69.2102 28.4887 69.9946 29.23 69.9946 30.318C69.9946 31.3972 69.2102 32.1473 68.2995 32.1473ZM60.4731 28.2286V29.506H63.5263C63.4328 30.2225 63.1968 30.7515 62.8355 31.1142C62.3882 31.5635 61.6973 32.0519 60.4801 32.0519C58.6038 32.0519 57.136 30.5304 57.136 28.6462C57.136 26.762 58.6038 25.2405 60.4801 25.2405C61.493 25.2405 62.2312 25.6421 62.7796 26.1551L63.6817 25.2493C62.9204 24.5169 61.907 23.9561 60.4871 23.9561C57.9129 23.9561 55.7527 26.0614 55.7527 28.6391C55.7527 31.2238 57.9113 33.3221 60.4871 33.3221C61.8774 33.3221 62.9204 32.8657 63.7452 32.0058C64.5855 31.1619 64.8516 29.9713 64.8516 29.0106C64.8516 28.7116 64.8285 28.4427 64.7806 28.2145H60.471C60.4731 28.2127 60.4731 28.2286 60.4731 28.2286ZM92.4855 29.2229C92.2333 28.5453 91.4726 27.2998 89.9113 27.2998C88.3645 27.2998 87.078 28.5223 87.078 30.318C87.078 32.0129 88.35 33.3363 90.0613 33.3363C91.4355 33.3363 92.2355 32.4923 92.5645 31.997L91.5446 31.3106C91.2064 31.8148 90.736 32.1456 90.0683 32.1456C89.393 32.1456 88.921 31.8378 88.6075 31.2309L92.6263 29.5591C92.6263 29.5608 92.4855 29.2229 92.4855 29.2229ZM88.3871 30.2313C88.3554 29.0655 89.2893 28.4728 89.957 28.4728C90.4839 28.4728 90.9226 28.7328 91.0726 29.1114L88.3871 30.2313ZM85.1226 33.1558H86.4419V24.2887H85.1226V33.1558ZM82.9554 27.9774H82.9075C82.6097 27.6218 82.0441 27.2998 81.322 27.2998C79.8226 27.2998 78.4409 28.6249 78.4409 30.3269C78.4409 32.0218 79.8156 33.3309 81.322 33.3309C82.0355 33.3309 82.6097 33.0072 82.9075 32.6445H82.9554V33.0779C82.9554 34.2297 82.3419 34.8507 81.3538 34.8507C80.5446 34.8507 80.0425 34.2669 79.8382 33.7786L78.6914 34.2598C79.021 35.0559 79.9 36.0413 81.3516 36.0413C82.8989 36.0413 84.2097 35.1267 84.2097 32.8957V27.4802H82.9624V27.9774C82.964 27.9774 82.9554 27.9774 82.9554 27.9774ZM81.4398 32.1473C80.529 32.1473 79.7677 31.3831 79.7677 30.3269C79.7677 29.2618 80.529 28.4905 81.4398 28.4905C82.3419 28.4905 83.0414 29.2707 83.0414 30.3269C83.0505 31.3831 82.3435 32.1473 81.4398 32.1473ZM98.6645 24.2887H95.5091V33.1558H96.8285V29.7979H98.6661C100.127 29.7979 101.563 28.7346 101.563 27.0468C101.563 25.359 100.132 24.2887 98.6645 24.2887ZM98.7032 28.5595H96.8269V25.5165H98.7032C99.6919 25.5165 100.25 26.3356 100.25 27.038C100.25 27.7333 99.6844 28.5595 98.7032 28.5595ZM106.852 27.2909C105.894 27.2909 104.905 27.7173 104.496 28.6462L105.667 29.1344C105.918 28.6462 106.38 28.4799 106.868 28.4799C107.552 28.4799 108.242 28.8903 108.258 29.6227V29.7165C108.022 29.5821 107.504 29.3768 106.884 29.3768C105.62 29.3768 104.34 30.0704 104.34 31.3707C104.34 32.5614 105.376 33.3256 106.53 33.3256C107.416 33.3256 107.904 32.9241 108.209 32.4587H108.256V33.1452H109.528V29.7484C109.528 28.1667 108.359 27.2909 106.852 27.2909ZM106.687 32.1473C106.255 32.1473 105.651 31.9351 105.651 31.3901C105.651 30.7037 106.405 30.4436 107.048 30.4436C107.629 30.4436 107.904 30.5693 108.249 30.7426C108.154 31.5388 107.485 32.1403 106.687 32.1473ZM114.169 27.4802L112.654 31.3265H112.606L111.037 27.4802H109.617L111.973 32.8568L110.63 35.845H112.004L115.628 27.4802H114.169ZM102.29 33.1558H103.61V24.2887H102.29V33.1558Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_118",
    x1: 36.738,
    y1: 14.3586,
    x2: 18.3767,
    y2: 19.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_118",
    x1: 47.8676,
    y1: 24.8443,
    x2: 25.4918,
    y2: 24.8443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_63_118",
    x1: 39.5378,
    y1: 26.9779,
    x2: 24.7157,
    y2: 51.8224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_63_118",
    x1: 23.3256,
    y1: 6.4396,
    x2: 29.9384,
    y2: 17.5356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.935,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore2);
export default __webpack_public_path__ + "static/media/store2.1ced7ad4fdf21c57140068f82a2e4c3d.svg";
export { ForwardRef as ReactComponent };